export default __webpack_public_path__ + "static/media/icon-date.c89deaeb.svg";